import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface HeadingModel extends BaseModel {
  variables?: { [key: string]: string } | HeadingVariables;
}

export interface HeadingVariables {
  Heading: string;
}

export class HeadingInitVariables implements HeadingVariables {
  Heading = '';
}

export class HeadingInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new HeadingInitVariables();
    this.variables = {...initVars};
    this.notifications = [new NotificationInitVariables()];
  }
}
